module.exports = __webpack_public_path__ + "img/img_moa问题反馈_2.18b31250.jpeg";